import api from '../components/backend/backend-api'
import i18n from "../i18n";

export  default {
  getProjectLanguages () {
       return api.getProjectLanguages().then(response =>
      new Promise((resolve, reject) =>
      {
        let languages = []
        response.forEach(locale=>
          languages.push({"locale": locale, "language": i18n.t('locale.' + locale)})

        )
        resolve(languages)
      }))

  },

  getLanguageText(locale) {
    if (typeof  locale == 'undefined' || locale=='')
      return ''
    return i18n.t('locale.' + locale)
  }
}

